export const defaultStyle = {
  Listcontainer: "",
  footerlinsMob: "text-center mx-[40px]",
  listmob: "py-20",
  className2: "lg:inline-block lg:w-auto w-full",
  className3: "text-[0.70rem] font-Regular text-slate-50 px-2",
  className4:
    "text-[0.70rem] font-Regular lg:before:content-['/'] before:pr-4 before:text-blue-500 text-slate-50 px-2 ",
}

export const footerMainLinks = {

  Listcontainer: "leading-13 md:leading-8 listcontainer md:text-left ListcontainerFooter",
  footerlinsMob: "text-center mx-[40px]",
  listmob: "mb-20 lg-mb-0",
  listLink: "block text-[12px] cursor-pointer hover:underline hover:text-oranage400 md:text-[18px] font-Regular leading-13 lg:leading-[30px] tracking-[0.45px] ",
  
}

export const footerSecondaryLinks = {
  Listcontainer: " Listcontainer text-white tracking-[0.45px] mb-0 text-bold cursor-pointer inline after:content-['|'] last:after:content-['']", 
  footerlinsMob: "text-center mx-[40px] ",
  listmob: "listmob text-center lg:text-left text-white mb-0 mt-0 lg:flex justify-end md:flex-wrap md:justify-center",
  listLink: "px-5 md:px-0 lg:px-0 lg:m-[2px] md:m-[0] hover:text-white hover:underline text-[10px] md:text-[16px] lg:text-[18px] font-Bold md:font-Regular lg:font-Regular",  
}



export const socialLinks = {
  Listcontainer: "Listcontainer w-full lg:w-auto lg:inline-block px-10",
  footerlinsMob: "text-center mx-[40px]",
  listmob: "py-20",
  className2: "lg:inline-block lg:w-auto w-full",
  className3: "text-[0.70rem] font-Regular text-slate-50 px-2",
  className4:
    "text-[0.70rem] font-Regular lg:before:content-['/'] before:pr-4 before:text-blue-500 text-slate-50 px-2 ",
}

export const brandLinks = {
  Listcontainer: "Listcontainer w-full lg:w-[175px] lg:inline-block mx-auto my-0",
  footerlinsMob: "text-center mx-[40px]",
  listmob: "pt-16 pb-6",
}

